import classNames from 'classnames';
import * as React from 'react';
import { extractProps } from '../helpers/themes.js';
import { marginPropDefs, MarginProps } from '../props.js';

const PROVIDERS = [
  'access-people-hr',
  'adp',
  'apple',
  'asana',
  'auth0',
  'aws',
  'aws-kms',
  'azure',
  'azure-key-vault',
  'bamboo-hr',
  'bamboohr',
  'better-auth',
  'bitbucket',
  'box',
  'breathe-hr',
  'bubble',
  'cal-dot-com',
  'calendly',
  'cas',
  'cezanne-hr',
  'classlink',
  'clerk',
  'clever',
  'cloudflare',
  'confluence',
  'cyberark',
  'datadog',
  'datasite',
  'discord',
  'dropbox',
  'duo',
  'firebase',
  'fourth',
  'frame-io',
  'front',
  'gcp-cloud-kms',
  'generic-oidc',
  'github',
  'gitlab',
  'godaddy',
  'google',
  'google-analytics',
  'google-calendar',
  'google-cloud',
  'google-drive',
  'google-mail',
  'helpscout',
  'hibob',
  'hubspot',
  'intercom',
  'intralinks',
  'intuit',
  'jira',
  'jumpcloud',
  'keycloak',
  'lastpass',
  'linear',
  'linkedin',
  'login-gov',
  'microsoft',
  'microsoft-onedrive',
  'microsoft-onenote',
  'microsoft-outlook',
  'microsoft-outlook-calendar',
  'microsoft-sharepoint',
  'microsoft-teams',
  'microsoft-todo',
  'miniorange',
  'net-iq',
  'next-auth',
  'notion',
  'okta',
  'onelogin',
  'oracle',
  'personio',
  'prefect',
  'pydantic-logfire',
  'ping-identity',
  'prefect',
  'pydantic-logfire',
  'react-native-expo',
  'rippling',
  'sailpoint',
  'salesforce',
  'segment',
  'sentry',
  'shibboleth',
  'simple-saml-php',
  'slack',
  'snowflake',
  'splunk',
  'stripe',
  'stripe-connect',
  'stytch',
  'supabase',
  'test-idp',
  'vercel',
  'vmware',
  'workday',
  'workos',
  'xero',
  'zendesk',
  'zoom',
] as const;

type ProviderIconType = (typeof PROVIDERS)[number];

interface ProviderIconProps
  extends React.ComponentPropsWithRef<'div'>,
    MarginProps {
  provider: ProviderIconType | undefined;
  size?: '1' | '2' | '3' | '4';
}

const ProviderIcon = React.forwardRef<HTMLDivElement, ProviderIconProps>(
  (props, forwardedRef) => {
    const {
      provider,
      size = '4',
      className,
      ...providerIconProps
    } = extractProps(props, marginPropDefs);

    return (
      <div
        {...providerIconProps}
        ref={forwardedRef}
        className={classNames('ProviderIcon', `size-${size}`, className)}
        data-provider={provider ?? undefined}
      />
    );
  },
);

ProviderIcon.displayName = 'ProviderIcon';

export { ProviderIcon };
export type { ProviderIconProps, ProviderIconType };
